/**
 * Razão do erro da certificação → frase da tela (E52.F3).
 *
 * Módulo próprio para que a tradução seja testável sem montar a página, e
 * para que cada razão tenha UMA frase: dizer "erro genérico" numa disputa de
 * item esconde exatamente o que o certificador precisa saber para agir.
 */
import { ptBR } from '@/i18n/pt-BR';
import type { CertificacaoErrorReason } from '@/lib/certificacao';

const MENSAGENS: Record<CertificacaoErrorReason, string> = {
  disputada: ptBR.certificacao.erroDisputada,
  nao_assumida: ptBR.certificacao.erroNaoAssumida,
  revisao_incompleta: ptBR.certificacao.erroRevisaoIncompleta,
  ja_assinado: ptBR.certificacao.erroJaAssinado,
  laudo_nao_pronto: ptBR.certificacao.erroLaudoNaoPronto,
  nao_encontrado: ptBR.certificacao.erroNaoEncontrado,
  sem_permissao: ptBR.certificacao.erroSemPermissao,
  rede: ptBR.certificacao.erroRede,
  desconhecido: ptBR.certificacao.erroGenerico,
};

export function mapCertificacaoError(reason: CertificacaoErrorReason | null): string {
  if (reason === null) return ptBR.certificacao.erroGenerico;
  return MENSAGENS[reason];
}
